import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3ad0778e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "userLayout",
  class: /*#__PURE__*/_normalizeClass(['user-layout-wrapper'])
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "user-layout-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-3ad0778e><div class=\"header\" data-v-3ad0778e><img src=\"" + _imports_0 + "\" class=\"logo\" alt=\"logo\" data-v-3ad0778e><span class=\"title\" data-v-3ad0778e>PT管理宝</span></div><div class=\"desc\" data-v-3ad0778e>用来辅助PT管理宝小程序的服务</div></div>", 1)
const _hoisted_5 = { class: "main" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_lock_outlined = _resolveComponent("lock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_form, {
            id: "formLogin",
            class: "user-layout-login",
            ref: "formLogin",
            model: _ctx.formState,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              (_ctx.isLoginError)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "error",
                    showIcon: "",
                    style: {"margin-bottom":"24px"},
                    message: "用户名或密码错误"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form_item, { name: "username" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    size: "large",
                    type: "text",
                    placeholder: "请输入用户名",
                    value: _ctx.formState.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.username) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_user_outlined, {
                        style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { name: "password" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_password, {
                    size: "large",
                    placeholder: "请输入登录密码",
                    autocomplete: "",
                    value: _ctx.formState.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_lock_outlined, {
                        style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "large",
                    type: "primary",
                    class: "login-button",
                    loading: _ctx.loginBtn,
                    disabled: _ctx.loginBtn,
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}